module.exports = __webpack_public_path__ + "static/media/Grotle_gaussian2.7bbd1078.png";